export default __webpack_public_path__ + "static/media/bg10.960672f4.jpg";